import { NgModule } from "@angular/core";

import { MenuDropdownComponent } from "./menu-dropdown.component";

@NgModule({
	declarations: [MenuDropdownComponent],
	exports: [MenuDropdownComponent],
})
export class MenuDropdownModule {}
